(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const link = e.target.closest('.slide__image-link');
    if (!link) return;
    
    // Jika slideshow sedang drag, jangan navigasi
    const slideshow = link.closest('slideshow-component');
    if (slideshow?.hasAttribute('dragging')) {
      e.preventDefault();
      return;
    }
    
    window.location.href = link.href;
  });
  } catch(e) { console.error(e); }
})();

})();
